import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';
import { enumData } from '@/decorators';

var default_1 = function (_super) {
  __extends(default_1, _super);

  function default_1() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeKeys = [];
    _this.cateList = [];
    _this.channelBreadCrump = {};
    _this.breadCrumpList = [];
    _this.listPending = false;
    _this.cateId = undefined;
    _this.channel = 1;
    _this.menuHeight = '';
    _this.menuList = [];
    return _this;
  }

  Object.defineProperty(default_1.prototype, "routeParams", {
    get: function get() {
      return this.$route.params;
    },
    enumerable: false,
    configurable: true
  });

  default_1.prototype.toggleBreadCrump = function (breadCrumpList) {
    this.breadCrumpList = [this.channelBreadCrump].concat(breadCrumpList);
  };

  default_1.prototype.toggleChannel = function (channel) {
    this.setChannel(Number(channel));
  };

  default_1.prototype.toggleCateId = function (cateId) {
    this.cateId = Number(cateId);
  };

  default_1.prototype.created = function () {
    if (!this.$route.query.channel) {
      if ('FaqListPage' === this.$route.name) {
        this.$router.push({
          name: 'FaqListPage',
          query: {
            channel: '1'
          }
        });
      }
    } else {
      this.cateId = this.$route.query.cate_id ? Number(this.$route.query.cate_id) : undefined;
      var channel = this.$route.query.channel ? Number(this.$route.query.channel) : 1;
      this.setChannel(channel);
    }

    window.addEventListener('resize', this.updateHeightTop);
  };

  default_1.prototype.destroyed = function () {
    window.removeEventListener('resize', this.updateHeightTop);
  };

  default_1.prototype.mounted = function () {
    this.updateHeightTop();
  };

  default_1.prototype.onQueryChannelChange = function (channel) {
    var newChannel = Number(channel);

    if (newChannel !== this.channel || !this.cateList.length) {
      this.setChannel(Number(channel));
    }

    this.updateHeightTop();
  };

  default_1.prototype.onQueryCateIdChange = function (cateId) {
    if (cateId === this.breadCrumpList[1].id) {
      this.breadCrumpList = this.breadCrumpList.slice(0, 2);
    }

    this.cateId = cateId;
    this.updateHeightTop();
  };

  default_1.prototype.setChannel = function (channel) {
    this.channel = channel;
    var targetChannel = this.menuList.find(function (faqChannel) {
      return faqChannel.value === channel;
    });
    this.channelBreadCrump = {
      id: undefined,
      title: this.t(targetChannel.text)
    };
    this.initNav();
  };

  default_1.prototype.handleCateClick = function (cat2, cat1) {
    var _a, _b;

    if ('FaqListPage' === this.$route.name && cat2.id === this.cateId) {
      return;
    }

    this.breadCrumpList = [this.channelBreadCrump].concat([{
      id: cat1.id,
      title: cat1.title
    }, {
      id: cat2.id,
      title: cat2.title
    }]);
    this.cateId = cat2.id;
    var scrollTop = (_b = (_a = this.$refs.menuCollapseRef) === null || _a === void 0 ? void 0 : _a.$el) === null || _b === void 0 ? void 0 : _b.scrollTop;
    this.$router.push({
      name: 'FaqListPage',
      query: {
        cate_id: this.cateId.toString(),
        channel: this.channel.toString()
      },
      params: {
        scrollTop: scrollTop.toString()
      }
    });
  };

  default_1.prototype.initNav = function () {
    return __awaiter(this, void 0, Promise, function () {
      var firstCateId;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.getCateList()];

          case 1:
            _a.sent();

            if (!this.cateList || !this.cateList.length) {
              return [2];
            }

            firstCateId = this.getFirstCateId();

            if (!firstCateId) {
              return [2];
            }

            if ('FaqListPage' === this.$route.name && !this.$route.query.cate_id) {
              this.cateId = firstCateId;
              this.setBreadCrumpList();
              this.$router.push({
                name: 'FaqListPage',
                query: {
                  cate_id: firstCateId.toString(),
                  channel: this.channel.toString()
                }
              });
            } else {
              this.setBreadCrumpList();
            }

            setTimeout(function () {
              var menuCollapseRef = _this.$refs.menuCollapseRef;

              if (menuCollapseRef && menuCollapseRef.$el) {
                menuCollapseRef.$el.scrollTop = Number(_this.routeParams.scrollTop);
              }
            }, 450);
            return [2];
        }
      });
    });
  };

  default_1.prototype.getFirstCateId = function () {
    for (var _i = 0, _a = this.cateList; _i < _a.length; _i++) {
      var cat1 = _a[_i];

      for (var _b = 0, _c = cat1.children; _b < _c.length; _b++) {
        var cat2 = _c[_b];
        return cat2.id;
      }
    }

    return undefined;
  };

  default_1.prototype.setBreadCrumpList = function () {
    for (var _i = 0, _a = this.cateList; _i < _a.length; _i++) {
      var cat1 = _a[_i];

      if (cat1.id === this.cateId) {
        this.breadCrumpList = [this.channelBreadCrump].concat([{
          id: cat1.id,
          title: cat1.title
        }]);
        return false;
      }

      for (var _b = 0, _c = cat1.children; _b < _c.length; _b++) {
        var cat2 = _c[_b];

        if (cat2.id === this.cateId) {
          this.breadCrumpList = [this.channelBreadCrump].concat([{
            id: cat1.id,
            title: cat1.title
          }, {
            id: cat2.id,
            title: cat2.title
          }]);
          return false;
        }
      }
    }
  };

  default_1.prototype.getCateList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.helpCenter.queryProblemCateList({
              channel: this.channel
            })];

          case 1:
            data = _a.sent().data;

            if (!data.length) {
              this.cateList = [];
              this.breadCrumpList = [];
              return [2];
            }

            this.activeKeys = data.filter(function (item) {
              return item.children && item.children.length;
            }).map(function (item) {
              return item.id;
            });
            this.cateList = data;
            return [2];
        }
      });
    });
  };

  default_1.prototype.jumpToSomeList = function (cateId) {
    this.$router.push({
      name: 'FaqListPage',
      query: {
        cate_id: cateId.toString(),
        channel: this.channel.toString()
      }
    });
  };

  default_1.prototype.initPage = function () {
    this.breadCrumpList = [];
    this.cateList = [];
  };

  default_1.prototype.updateHeightTop = function () {
    var _this = this;

    this.$nextTick(function () {
      var headerFooter = 230;
      _this.menuHeight = window.innerHeight - headerFooter + 'px';

      _this.$util.scrollToTopByCss();
    });
  };

  __decorate([enumData('FaqChannelEnum')], default_1.prototype, "menuList", void 0);

  __decorate([Watch('$route.query.channel')], default_1.prototype, "onQueryChannelChange", null);

  __decorate([Watch('$route.query.cate_id')], default_1.prototype, "onQueryCateIdChange", null);

  __decorate([loading('listPending')], default_1.prototype, "initNav", null);

  default_1 = __decorate([Component], default_1);
  return default_1;
}(Vue);

export default default_1;